import { ColumnDef } from '@tanstack/react-table'
import { GetDynamicPageByIdDataResponse } from '@/modules/client-setting/type'
import { Badge } from '@/common/ui/badge'
import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { Pencil } from 'lucide-react'
import DeleteSectionFromPageModal from './components/DeleteSectionFromPage'

export const columns: ColumnDef<GetDynamicPageByIdDataResponse>[] = [
	{
		accessorKey: 'order',
		header: 'ลำดับ',
	},
	{
		accessorKey: 'dynamicSection.name',
		header: 'ชื่อ',
	},
	{
		accessorKey: 'dynamicSection.type',
		header: 'ประเภท',
		cell: ({ row }) => {
			const type = row.original.dynamicSection?.type
			const typeMap: Record<string, string> = {
				GAME_LIST: 'รายการเกม',
				LEADERBOARD: 'Leaderboard',
				LOTTO_ANNOUNCEMENT: 'รายการล็อตโต้',
				GAME_SUGGESTION: 'แนะนำเกม',
			}
			return (
				<Badge variant={type === 'GAME_LIST' ? 'default' : 'default'}>
					{type ? typeMap[type] || type : '-'}
				</Badge>
			)
		},
	},
	{
		accessorKey: 'id',
		header: 'แก้ไข',
		cell: ({ row }) => (
			<Link to={`/operator/dynamic-section/${row.original.dynamicSection?.id}`}>
				<Button variant="ghost" size="icon">
					<Pencil className="h-4 w-4" />
				</Button>
			</Link>
		),
	},
	{
		accessorKey: 'delete',
		header: 'ลบ',
		cell: ({ row }) => (
			<DeleteSectionFromPageModal
				dynamicPageSectionId={row.original.id || ''}
			/>
		),
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง',
		cell: ({ row }) => new Date(row.original.createdAt).toLocaleString(),
	},
	{
		accessorKey: 'updatedAt',
		header: 'วันที่แก้ไข',
		cell: ({ row }) =>
			row.original.updatedAt
				? new Date(row.original.updatedAt).toLocaleString()
				: '-',
	},
]
